import { AbstractCellController } from '../generated'

export default AbstractCellController

/** @constructor @extends {AbstractCellController} @suppress {checkTypes} */ function _CellController() {}
AbstractCellController.__implement(
 _CellController.prototype = /** @type {!AbstractCellController} */ ({

 }),
)

export class CellComponent {
 static getClasses(splendid) {
  const CSS = splendid.css('calendar-new.js')
  // const CellSelected = CSS`CellSelected`
  const classes = /** @type {ru.hulkmoto.ICellController.Classes} */ ({
   CellSelected: CSS`CellSelected`,
   CellProjectEnd: CSS`CellProjectEnd`,
   CellProjectStart: CSS`CellProjectStart`,
   CellProjected: CSS`CellProjected`,
   RangeSelected: CSS`RangeSelected`,
   CellOccupied: CSS`CellOccupied`,
   CellPast: CSS`CellPast`,
  })
  return classes
 }
}